import { useState } from "react";
import { connect } from "react-redux";
import { Tabs, Tab } from "react-bootstrap"; // Importa Tabs y Tab

import Sidebar from "../../components/Navigation/Sidebar";
import Topbar from "../../components/Navigation/Topbar";
import PreOrdersTable from "./preOrdersTable";
import CreatePreOrder from "./createPreOrder";


export const MESSAGE_STATUS_PENDIENTE = 'PENDING';
export const MESSAGE_STATUS_COMPLETADO = 'COMPLETED';
export const MESSAGE_STATUS_INCIDENCIA = 'FAILED';
export const MESSAGE_STATUS_REINTENTO = 'RETRY';

function PreOrdersPage() {
    const [activeTab, setActiveTab] = useState('pendiente');

    const handleSelectTab = (key) => {
        setActiveTab(key);
    };

    const statusMap = {
        pendiente: MESSAGE_STATUS_PENDIENTE,
        completado: MESSAGE_STATUS_COMPLETADO,
        incidencia: MESSAGE_STATUS_INCIDENCIA,
    };

    return (
        <div>
            <div id='wrapper'>
                <Sidebar />
                <div id='content-wrapper' className='d-flex flex-column'>
                    <div id='content'>
                        <Topbar />
                        <div className='container-fluid'>
                            <div className='d-sm-flex align-items-center mb-1'>
                                <h1 className='h3 mb-0 text-gray-800 mr-3'>Créditos</h1>
                                <CreatePreOrder />
                            </div>
                            <div className='card shadow mb-4'>
                                <div className='card-header py-3'>
                                    <Tabs
                                        id="preorders-status-tabs"
                                        activeKey={activeTab}
                                        onSelect={handleSelectTab}
                                        className="mb-3"
                                        mountOnEnter 
                                        unmountOnExit
                                    >
                                        <Tab eventKey="pendiente" title="Pendiente">
                                            {activeTab === 'pendiente' && (
                                                <PreOrdersTable filterStatus={statusMap.pendiente} />
                                            )}
                                        </Tab>
                                        <Tab eventKey="completado" title="Completado">
                                            {activeTab === 'completado' && (
                                                <PreOrdersTable filterStatus={statusMap.completado} />
                                            )}
                                        </Tab>
                                        <Tab eventKey="incidencia" title="Incidencia">
                                            {activeTab === 'incidencia' && (
                                                <PreOrdersTable filterStatus={statusMap.incidencia} />
                                            )}
                                        </Tab>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(PreOrdersPage);